<template>
  <div>
    <div class="disclaimer">{{ $t('external_pos.manual_file_upload') }}</div>
    <TipBox info :title="$t('external_pos.md_upload')">
      <div v-html="$t('external_pos.md_upload_description')"></div>
      <ul>
        <li><b>{{$t('external_pos.path')}}:</b>  C:/POSERA/MaitreD/DATA/ConfigExport.xml</li>
      </ul>
    </TipBox>
    <div style="display: flex; flex-direction: column; align-items: center">
      <input type="file" @change="loadTextFromFile" style="margin-bottom: 20px">
      <button class="btn btn-primary" @click="() => this.fileCallback(fileData)" :disabled="!fileData">
        {{ $t('external_pos.upload') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExternalInventoryUpdaterManualFile",
  props: {
    fileCallback: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      fileData: undefined,
      supportedTypes: ['text/xml']
    }
  },

  methods: {
    loadTextFromFile(ev) {
      let file = ev.target.files[0];
      if (!file) {
        return;
      }
      if (!this.supportedTypes.includes(file.type)) {
        let toastMsg = this.$t('unsupported_file_type') + `. ${file.type}`;
        toast(toastMsg, 'error');
        return;
      }
      let reader = new FileReader();
      reader.onload = e => this.fileData = e.target.result;
      reader.readAsText(file);
    }
  }
}
</script>

<style lang="scss" scoped>
.disclaimer {
  margin-bottom: 15px;
  font-weight: bold;
  color: indianred;
}
</style>